import { render, staticRenderFns } from "./FriendlyIds.vue?vue&type=template&id=305ae7f6"
import script from "./FriendlyIds.vue?vue&type=script&lang=ts"
export * from "./FriendlyIds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305ae7f6')) {
      api.createRecord('305ae7f6', component.options)
    } else {
      api.reload('305ae7f6', component.options)
    }
    module.hot.accept("./FriendlyIds.vue?vue&type=template&id=305ae7f6", function () {
      api.rerender('305ae7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/FriendlyIds.vue"
export default component.exports